import { Css, RouteTabWithContent, TabsWithContent } from "@homebound/beam";
import { useMemo } from "react";
import { createPlanPackageTakeoffUrl } from "src/RouteUrls";
import { PlanPackageIncomingSlotStatus } from "src/generated/graphqlTypes";
import { useTakeoffsStore } from "src/routes/libraries/plan-package/takeoffs/TakeoffsManagerContext";
import { TakeoffsManagerItemsTab } from "src/routes/libraries/plan-package/takeoffs/TakeoffsManagerItemsTab";
import { TakeoffsHeader } from "src/routes/libraries/plan-package/takeoffs/components/TakeoffsHeader";
import * as planPaths from "src/routing/domains/libraries/plan/planPaths";

/**
 * Takeoffs page content. Expects `PlanPackageTakeoffSideNavLayout` (provider + SideNav) above it.
 */
export function PlanPackageTakeoffPage() {
  const planPackage = useTakeoffsStore((state) => state.planPackage);
  const { id: ppId, version } = planPackage;

  const pendingSlotCount = planPackage.incomingSlots.filter(
    (s) => s.status.code === PlanPackageIncomingSlotStatus.Pending,
  ).length;

  const tabs: RouteTabWithContent[] = useMemo(
    () => [
      {
        name: "Items",
        path: planPaths.planTakeoffsRoute.path,
        href: createPlanPackageTakeoffUrl(ppId, version.id),
        render: () => <TakeoffsManagerItemsTab />,
      },
    ],
    [version.id, ppId],
  );

  return (
    <>
      <TakeoffsHeader planPackage={planPackage} pendingSlotCount={pendingSlotCount} />
      <TabsWithContent tabs={tabs} includeBottomBorder contentXss={Css.pl3.pr2.$} />
    </>
  );
}
